module.exports = __webpack_public_path__ + "static/inpowered-openx-precisely-main-mobile-d74ad64bce03297fa948bdfe272e7f6d.png";